/** Ernährung von heute und der Score-Schnitt der Woche - fuer Bereichsseiten (F-35 E, BE-03). */
import { useLiveQuery } from 'dexie-react-hooks';

import { db } from '@/db/schema';
import { kennTage, trainingstage } from '@/db/repositories/ernaehrungUeberblick';
import { tagZeile } from '@/domain/ernaehrung/ueberblick';
import type { ErnaehrungsEinstellungen } from '@/domain/ernaehrung/typen';
import type { LocalDate } from '@/domain/types';
import { startOfWeek } from '@/lib/datetime';

export function useErnaehrungHeute(heute: LocalDate) {
  return useLiveQuery(async () => {
    const e = await db.ernaehrungsEinstellungen.get('standard');
    const [gegessen, getraenke, training, lebensmittel, rezepte, woche] = await Promise.all([
      db.gegessen.get(heute), db.getraenke.where('datum').equals(heute).toArray(), trainingstage(heute, heute),
      db.lebensmittel.toArray(), db.rezepte.toArray(), kennTage(startOfWeek(heute), heute),
    ]);
    const daten = { lebensmittel: new Map(lebensmittel.map((l) => [l.id, l])), rezepte: new Map(rezepte.map((r) => [r.id, r])) };
    const zeile = tagZeile({ datum: heute, training: training.has(heute), getraenke, ...(gegessen ? { gegessen } : {}) }, daten, e);
    const scores = woche.flatMap((t) => (t.score !== null ? [t.score] : []));
    return {
      einstellungen: e as ErnaehrungsEinstellungen | undefined, zeile,
      schnitt: scores.length ? Math.round((scores.reduce((a, b) => a + b, 0) / scores.length) * 10) / 10 : null, tage: scores.length,
    };
  }, [heute]);
}
